import React from 'react'
import { Tooltip } from '@material-ui/core'
import { IPublishedGraphicBasic } from '../../types/publishedGraphic'
import * as date from '../../services/date'
import { getPublishedGraphicTag } from '../../services/publishedGraphic'
import { FlexContainer } from '../../layouts'
import { H3 } from '../StyledText'
import {
  StyledSearchItemWrapper,
  StyledSearchItemPreview,
  StyledSearchItemFooter,
  StyledSearchItemCaption,
  StyledMediaTypeLabel,
} from './styled'

export const PublishedGraphicsListItem = ({
  id,
  title,
  slugline,
  byline,
  publishedDate = '',
  thumbnailURI,
  previewImageURI,
  graphicType,
  graphicSubType,
  mediaType,
}: IPublishedGraphicBasic) => (
  <StyledSearchItemWrapper to={`/graphic/${id}`} className="pack-list-item">
    <StyledSearchItemPreview thumbnail={previewImageURI || thumbnailURI}>
      <StyledMediaTypeLabel
        className="type-tag"
        label={getPublishedGraphicTag(graphicType, graphicSubType, mediaType)}
        color="primary"
      />
    </StyledSearchItemPreview>
    <StyledSearchItemFooter>
      <Tooltip title={`Title: ${title || 'Undefined'}`}>
        <H3>{title}</H3>
      </Tooltip>
      <Tooltip title={`Slug: ${slugline}`}>
        <StyledSearchItemCaption className="show-eclipsis">
          {slugline}
        </StyledSearchItemCaption>
      </Tooltip>
      <FlexContainer>
        <Tooltip title={`Byline: ${byline}`}>
          <StyledSearchItemCaption className="show-eclipsis">
            {byline}
          </StyledSearchItemCaption>
        </Tooltip>
        <StyledSearchItemCaption className="delimiter">
          |
        </StyledSearchItemCaption>
        <Tooltip title={`Publish date: ${date.format(publishedDate)}`}>
          <StyledSearchItemCaption className="show-eclipsis">
            {date.formatWithToday(publishedDate)}
          </StyledSearchItemCaption>
        </Tooltip>
      </FlexContainer>
    </StyledSearchItemFooter>
  </StyledSearchItemWrapper>
)
